import { useState } from 'react';

import { type TabOption, Tabs } from '@/components/chariot-ui';

import { MyStats } from './leaderboard/MyStats';
import { ScoreBoard } from './leaderboard/ScoreBoard';

const leaderboardTabs: TabOption[] = [
  { label: 'Score Board', value: 'scoreboard' },
  { label: 'My Stats', value: 'mystats' },
];

export function Leaderboard() {
  const [selectedTab, setSelectedTab] = useState<TabOption>(leaderboardTabs[0]);

  return (
    <div className="flex h-full flex-col">
      <Tabs
        tabs={leaderboardTabs}
        selected={selectedTab}
        onSelect={setSelectedTab}
        variant="primary"
      />
      <div className="mt-4 h-full overflow-y-auto">
        {selectedTab.value === 'scoreboard' && <ScoreBoard />}
        {selectedTab.value === 'mystats' && <MyStats />}
      </div>
    </div>
  );
}
